import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { Ticket } from '../types/tickets/types'


type TicketStore = {
    ticket: Ticket | null
    setTicket: (ticket: Ticket) => void
    clearTicket: () => void
}

export const useTicketStore = create<TicketStore>()(
    persist(
        (set) => ({
            ticket: null,
            setTicket: (ticket) => set({ ticket }),
            clearTicket: () => set({ ticket: null }),
        }),
        { name: 'ticket-storage' }
    )
) 